import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { fmtCurrency, fmtDate } from "@/lib/format";
import { Panel, SectionLabel } from "@/components/common/ui-kit";

export const CompanyFeesPanel = ({ companyId }) => {
  const [s, setS] = useState(null);
  useEffect(() => { api.get(`/companies/${companyId}/fees-summary`).then((r) => setS(r.data)).catch(() => setS(null)); }, [companyId]);
  if (!s?.count) return null;
  const n = s.next;
  return (
    <Panel className="p-5" data-testid="company-fees-panel">
      <SectionLabel>Canoni attivi</SectionLabel>
      <div className="mt-3 flex items-end justify-between gap-4">
        <div><p className="text-xs text-slate-500">Totale mensile equivalente</p>
          <p className="font-display text-2xl font-bold text-ink" data-testid="company-fees-monthly">{fmtCurrency(s.monthly_total)}<span className="ml-1 text-xs font-normal text-slate-500">+ IVA / mese</span></p></div>
        <p className="text-sm text-slate-600" data-testid="company-fees-count">{s.count} {s.count === 1 ? "canone" : "canoni"}</p>
      </div>
      {n && <Link to={`/contratti/${n.contract_id}`} className="mt-4 block rounded-control bg-slate-50 p-3 text-sm transition-colors hover:bg-slate-100" data-testid="company-fees-next">
        <p className="text-xs text-slate-500">Prossimo da fatturare{n.overdue && <span className="ml-1 font-semibold text-red-600">· scaduto</span>}</p>
        <p className="mt-0.5 font-medium text-ink">{fmtDate(n.date)} · {fmtCurrency(n.amount)}</p>
        <p className="truncate text-xs text-slate-500">{n.contract_number} · {n.description} · periodo {fmtDate(n.period.start)} – {fmtDate(n.period.end)}</p>
      </Link>}
    </Panel>
  );
};
